import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  GoogleAuthProvider,
  signInWithPopup,
  signInWithEmailAndPassword
} from "firebase/auth";
import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";

import { auth, db } from "../Firebase";
import "../styles/Login.css";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  // ================= EMAIL + PASSWORD LOGIN =================
  const handleEmailLogin = async () => {
  if (!email || !password) {
    alert("Please enter email and password");
    return;
  }

  try {
    const userCred = await signInWithEmailAndPassword(
      auth,
      email,
      password
    );

    const user = userCred.user;

    // 🔐 Save Firebase token
    const token = await user.getIdToken();
    localStorage.setItem("token", token);

    // 📄 Get user document
    const userRef = doc(db, "users", user.uid);
    const userSnap = await getDoc(userRef);

    if (!userSnap.exists()) {
      alert("User data not found");
      return;
    }

    const userData = userSnap.data();

    // ⏱ update last login
    await updateDoc(userRef, {
      lastLoginAt: new Date()
    });

    // 🚦 ROLE BASED REDIRECT
    if (!userData.role) {
      navigate("/courses"); // index / role selection page
    } else if (userData.role === "student") {
      navigate("/courses");
    } else if (userData.role === "teacher") {
      navigate("/teacherCourse");
    }

  } catch (error) {
    if (error.code === "auth/user-not-found") {
      alert("User not found. Please sign up.");
    } else if (error.code === "auth/wrong-password") {
      alert("Incorrect password");
    } else {
      alert(error.message);
    }
  }
};


  // ================= GOOGLE LOGIN =================
    const handleGoogleLogin = async () => {
    try {
      const provider = new GoogleAuthProvider();
      await signInWithPopup(auth, provider);

      // 🚨 WAIT FOR FIREBASE TO RESTORE SESSION
      onAuthStateChanged(auth, async (user) => {
        if (!user) return;

        const token = await user.getIdToken();
        localStorage.setItem("token", token);

        const userRef = doc(db, "users", user.uid);
        const userSnap = await getDoc(userRef);

        // First login
        if (!userSnap.exists()) {
          await setDoc(userRef, {
            uid: user.uid,
            fullName: user.displayName,
            email: user.email,
            role: "",
            profileImage: user.photoURL || "",
            phone: user.phoneNumber || "",
            isVerified: user.emailVerified,
            provider: "google",
            createdAt: new Date(),
            lastLoginAt: new Date()
          });

          navigate("/");
          return;
        }

        await updateDoc(userRef, { lastLoginAt: new Date() });

        const userData = userSnap.data();

        if (!userData.role || userData.role === "student") {
          navigate("/courses");
        } else if (userData.role === "teacher") {
          navigate("/teacherCourse");
        }
      });

    } catch (error) {
      console.error(error);
      alert("Google login failed");
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <h1>Log in to your Vidify Account</h1>

        <button className="btn-google" onClick={handleGoogleLogin}>
          Login with Google
        </button>

        <button className="btn-facebook" disabled>
          Login with Facebook
        </button>

        <div className="login-divider">
          <span>or</span>
        </div>

        <label>Email</label>
        <input
          type="email"
          placeholder="example@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <label>Password</label>
        <div className="password-wrapper">
          <input
            type={showPassword ? "text" : "password"}
            placeholder="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <span className="eye" onClick={() => setShowPassword(!showPassword)}>
            👁
          </span>
        </div>

        <div className="forgot">Forgot Password?</div>

        <button className="btn-primary" onClick={handleEmailLogin}>
          Start Learning
        </button>

        <p className="signup-text">
          New to Vidify?{" "}
          <span onClick={() => navigate("/signup")}>Sign Up</span>
        </p>
      </div>
    </div>
  );
};

export default Login;
